import {
  facetsContain,
  NoResultsV2,
  PromptTabs,
  type Filter,
  type Prompt,
} from "@1js/pl-card-components";
import * as React from "react";
import { ShowMore } from "../AllPrompts/ShowMore.web";
import { PromptCardPanel, type PromptCardPanelProps } from "./PromptCardPanel";
import { SectionHeader } from "./SectionHeader";

export type PromptsSectionProps = PromptCardPanelProps & {
  seeAllFilter: Record<string, string[]>;
  allFilteredPrompts: Prompt[];
  collapsedViewPromptsCount: number;
  headerTitle: string;
  isShowHasMore: boolean;
  hasMore?: boolean;
  isLoading: boolean;
  handleCardFocus: () => void;
  onMoreClicked: () => void;
  selectedFacets: Record<string, string[]>;
  filters: Filter[];
  handleFilterChange: (
    selectedValues: Record<string, string[]>,
    filters: Filter[]
  ) => void;
  isMetaOsV2?: boolean;
  isMetaOsV2HomePage?: boolean;
  selectedTab?: PromptTabs;
};

export const PromptsSection: React.FC<PromptsSectionProps> = ({
  seeAllFilter,
  allFilteredPrompts,
  collapsedViewPromptsCount,
  headerTitle,
  prompts,
  resultsAnnouncementId,
  promptsToDisplay,
  setLastFocusedPromptId,
  setCurrentFocusedPromptId,
  promptRefs,
  currentFocusedPromptId,
  isWorkgroupPublishingEnabled,
  shareToWorkgroup,
  handleShareViaCopyLinkClicked,
  handleShareViaEmailClicked,
  handleCardClick,
  onPromptBookmarkToggled,
  onDelete,
  groups,
  handlePromptsTabSelected,
  onBookmarkToggled,
  setDialogOpen,
  isShowHasMore,
  hasMore,
  isLoading,
  handleCardFocus,
  onMoreClicked,
  selectedFacets,
  filters,
  handleFilterChange,
  isMetaOsV2,
  isMetaOsV2HomePage,
  selectedTab,
}) => {
  const isDetailedViewEnabled = facetsContain(seeAllFilter, selectedFacets);

  if (allFilteredPrompts.length === 0) {
    return isMetaOsV2 && selectedTab === PromptTabs.LikedPrompts ? (
      <NoResultsV2 />
    ) : null;
  }

  return (
    <>
      {!isMetaOsV2 && (
        <SectionHeader
          title={headerTitle}
          selectedFacets={selectedFacets}
          filters={filters}
          handleFilterChange={handleFilterChange}
          seeAllFilter={seeAllFilter}
          isSeeAllButtonEnabled={
            allFilteredPrompts.length > collapsedViewPromptsCount
          }
        />
      )}
      <PromptCardPanel
        prompts={prompts}
        resultsAnnouncementId={resultsAnnouncementId}
        promptsToDisplay={
          isDetailedViewEnabled
            ? promptsToDisplay
            : isMetaOsV2
              ? allFilteredPrompts
              : allFilteredPrompts.slice(0, collapsedViewPromptsCount)
        }
        setLastFocusedPromptId={setLastFocusedPromptId}
        setCurrentFocusedPromptId={setCurrentFocusedPromptId}
        promptRefs={promptRefs}
        currentFocusedPromptId={currentFocusedPromptId}
        isWorkgroupPublishingEnabled={isWorkgroupPublishingEnabled}
        shareToWorkgroup={shareToWorkgroup}
        handleShareViaCopyLinkClicked={handleShareViaCopyLinkClicked}
        handleShareViaEmailClicked={handleShareViaEmailClicked}
        handleCardClick={handleCardClick}
        onPromptBookmarkToggled={onPromptBookmarkToggled}
        onDelete={onDelete}
        groups={groups}
        handlePromptsTabSelected={handlePromptsTabSelected}
        onBookmarkToggled={onBookmarkToggled}
        setDialogOpen={setDialogOpen}
        isMetaOsV2={isMetaOsV2}
        isMetaOsV2HomePage={isMetaOsV2HomePage}
      />
      {isDetailedViewEnabled && (
        <ShowMore
          isShowHasMore={isShowHasMore}
          hasMore={hasMore}
          isLoading={isLoading}
          handleCardFocus={handleCardFocus}
          onMoreClicked={onMoreClicked}
        />
      )}
    </>
  );
};
